import { useMemo } from "react";
import type { HydratedUserSnapshots } from "@/utils/pnl/pnl-chart";

/** Compute the earliest and latest snapshot timestamps across all users. */
export function useSnapshotTimestamps(users: HydratedUserSnapshots[]) {
  return useMemo(() => {
    let earliest = Infinity;
    let latest = 0;
    for (const u of users) {
      for (const s of u.snapshots) {
        const t = s.createdAt.getTime();
        if (t > latest) latest = t;
        if (t < earliest) earliest = t;
      }
    }
    return {
      earliestSnapshotTimestamp: Number.isFinite(earliest) ? earliest : 0,
      latestSnapshotTimestamp: latest,
    };
  }, [users]);
}
